export const Settings = {
  Opacity: 'settings_opacity',
  SkipWithoutML: 'settings_skip_without_ml'
};
